import { faEnvelope, faPhone, faUser } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react'
import { useForm } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import { Link } from 'react-router-dom';
import Button from '../../../Components/Button/Button';
import Input from '../../../Components/Input/Input'
import Style from '../Auth.module.css'


const Register = () => {
    const history=useHistory()
    const { register, handleSubmit, formState: { errors } } = useForm();
    const onSubmit = (data)=>{
        history.push('./confirm',data)
    }
    return (
        <div className={`pageHolder ${Style.LoginPageHolder}`}>
            <form onSubmit={handleSubmit(onSubmit)} className='formHolder'>
                <img className={Style.ImageHolder} src="/Assets/Images/Regular/Logo.png" alt="ElectronicSteps" />
                <label htmlFor="name" > :نام <FontAwesomeIcon icon={faUser}/></label>
                <Input 
                id='name' 
                {...register("name", { required: true })} 
                 type={'text'} 
                inputtype={errors.name ? "valid" : "text"}
                style={{direction:'rtl'}}
                /> 

                <label htmlFor="lastname" > : نام خانوادگی <FontAwesomeIcon icon={faUser}/></label>
                <Input 
                id='lastname' 
                {...register("lastname", { required: true })} 
                 type={'text'} 
                inputtype={errors.lastname ? "valid" : "text"}
                style={{direction:'rtl'}}
                /> 

                                
                <label htmlFor="phoneNumber" > :شماره همراه <FontAwesomeIcon icon={faPhone}/></label>
                <Input 
                id='phoneNumber' 
                {...register("phoneNumber", { required: true })} 
                maxLength='11' type={'tel'} 
                inputtype={errors.phoneNumber ? "valid" : "text"}
                style={{direction:'rtl'}}
                /> 
                                
                <label htmlFor="email" > : ایمیل <FontAwesomeIcon icon={faEnvelope}/></label>
                <Input 
                id='email' 
                {...register("email", { required: true })} 
                 type={'mail'} 
                inputtype={errors.phoneNumber ? "valid" : "text"}
                style={{direction:'rtl'}}
                /> 



                <Button Value='ورود' ClassBtn={'confirmBtn'}/>
                
                <p className={Style.ChangeAuth}>حساب کاربری دارید؟<Link to='/login'>ورود</Link></p>
            </form>
        </div>
    )
}

export default Register
